import { useMemo, useState } from 'react'
import * as TomadaHttp from '../../../../../services/api/https/patio/tomada.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE: 'Salvando informações da tomada',
  SUCCESS: 'Salvo com sucesso',
}

const MANDATORY_FIELDS = {
  NUMERO_REF: 'O número de referência deve ser preenchido',
  SEQUENCIA: 'A sequência deve ser preenchida',
}

const INITIAL = {
  id: undefined,
  numero_referencia: '',
  tp_id: 0,
  sequencia: undefined,
  status: 'Disponível',
  actived: true,
}

export default function useTomadaModal() {
  const [state, setState] = useState({
    tomada: { ...INITIAL },
    loadingMessage: LOAD_MESSAGE.NONE,
    errorMessage: null,
  })

  const localDispatch = useMemo(() => {
    return {
      start(tomada) {
        setState(prev => ({
          ...prev,
          tomada: tomada ? { ...tomada } : { ...INITIAL },
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },
      onChange(field, value) {
        setState(prev => ({ ...prev, tomada: { ...prev.tomada, [field]: value } }))
      },
      onBtnSalvarClicked(selectedTp) {
        const t = state.tomada
        if (!t.numero_referencia || String(t.numero_referencia).trim() === '')
          setState(prev => ({ ...prev, errorMessage: MANDATORY_FIELDS.NUMERO_REF }))
        else if (
          t.sequencia === undefined ||
          t.sequencia === null ||
          String(t.sequencia).trim() === '' ||
          isNaN(Number(t.sequencia))
        )
          setState(prev => ({ ...prev, errorMessage: MANDATORY_FIELDS.SEQUENCIA }))
        else if (!selectedTp || selectedTp === 0)
          setState(prev => ({ ...prev, errorMessage: 'Selecione o Operador Logístico' }))
        else setState(prev => ({ ...prev, errorMessage: null, loadingMessage: LOAD_MESSAGE.SAVE }))
      },
      clearError() {
        setState(prev => ({ ...prev, errorMessage: null, loadingMessage: LOAD_MESSAGE.NONE }))
      },
      async save(selectedTp) {
        try {
          const payload = {
            ...state.tomada,
            numero_referencia: (state.tomada.numero_referencia || '').trim(),
            sequencia: Number(state.tomada.sequencia),
            tp_id: state.tomada.tp_id || selectedTp,
            status: state.tomada.status || 'Disponível',
            actived: !!state.tomada.actived,
          }
          const saved = await TomadaHttp.saveTomada(payload)
          setState(prev => ({ ...prev, errorMessage: null, loadingMessage: LOAD_MESSAGE.SUCCESS }))
          return saved
        } catch (err) {
          setState(prev => ({
            ...prev,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: errorHandler(err),
          }))
          throw err
        }
      },
      reset() {
        setState({ tomada: { ...INITIAL }, loadingMessage: LOAD_MESSAGE.NONE, errorMessage: null })
      },
    }
  }, [state.tomada])

  return { state, localDispatch }
}
